var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurExpertise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 4.5,
    fill: "black",
    stroke: "#DC2418"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8338 23.3337L38.9675 14H20.9675L13.1012 23.3337L12.5012 24L13.035 24.6663L29.9688 46L47.435 24L46.835 23.3337H46.8338ZM45.1 23.3337H31.7L38.3663 15.4L45.1 23.3337ZM29.9 23.3337L22.9663 15.3338H36.7L29.9 23.3337ZM21.4338 15.5338L28.1675 23.3337H14.8337L21.4338 15.5338ZM29.3 24.6663V43L14.7 24.6663H29.3ZM30.6338 43V24.6663H45.1675L30.6338 43Z",
    fill: "#DC2418"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurExpertise);
export default __webpack_public_path__ + "static/media/ourExpertise.b72ebf58bb6503c7ab1ca7dc5f34f468.svg";
export { ForwardRef as ReactComponent };